import { reclaimAccessDefaultsSchema } from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import * as z from "zod";

export const updateReclaimAccessDefaults = {
  name: "updateReclaimAccessDefaults" as const,
  input: z.object({ defaults: reclaimAccessDefaultsSchema }),
  output: z.object({ defaults: reclaimAccessDefaultsSchema }),
};
